/*import React, { useEffect, useState } from "react";
import FilterIcon from "../../assets/svg/filter.svg";
import { getAttributes } from "../../Services/AttributeService";

const Sidebar = ({ onFilterChange }) => {
  const [attributes, setAttributes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedFilters, setSelectedFilters] = useState({});
  const [isCustomProductsSelected, setIsCustomProductsSelected] = useState(false);

  useEffect(() => {
    const ac = new AbortController();
    (async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await getAttributes({ attributeIds:[1,2,4] });
        setAttributes(response.data || []);
      } catch (err) {
        if (err.name !== "AbortError") {
          setError(err.message || "Failed to load filters");
        }
      } finally {
        setLoading(false);
      }
    })();
    return () => ac.abort();
  }, []);

  const handleCheckboxChange = (attributeName, valueId, valueName) => {
    setSelectedFilters((prev) => {
      const attributeFilters = prev[attributeName] || [];
      const isSelected = attributeFilters.some((item) => item.id === valueId);

      const updatedFilters = {
        ...prev,
        [attributeName]: isSelected
          ? attributeFilters.filter((item) => item.id !== valueId)
          : [...attributeFilters, { id: valueId, name: valueName }],
      };

      // If any other filter is selected, uncheck custom products
      const hasOtherFilters = Object.keys(updatedFilters).some(key => key !== 'isCustomProduct' && updatedFilters[key].length > 0);
      if (hasOtherFilters) {
        setIsCustomProductsSelected(false);
        updatedFilters.isCustomProduct = [];
      }

      // Call parent callback if provided
      if (onFilterChange) {
        onFilterChange(updatedFilters);
      }

      return updatedFilters;
    });
  };

  const handleCustomProductsChange = () => {
    const newValue = !isCustomProductsSelected;
    setIsCustomProductsSelected(newValue);

    // If custom products is selected, clear all other filters and uncheck them
    if (newValue) {
      setSelectedFilters({});
    }

    // Call parent callback with custom products filter
    if (onFilterChange) {
      const filtersToSend = {
        isCustomProduct: newValue ? [true] : [],
      };
      onFilterChange(filtersToSend);
    }
  };

  const isChecked = (attributeName, valueId) => {
    const attributeFilters = selectedFilters[attributeName] || [];
    return attributeFilters.some((item) => item.id === valueId);
  };

  return (
    <>
      <div className="sidebar navbar-expand-xl">
        <button
          className="navbar-toggler button btn-solid"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#sidebarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          Sort
          <img className={'img-fluid'} src={FilterIcon} alt="" />
        </button>
        <div className="sidebar-content collapse navbar-collapse" id="sidebarNav">
         
          <div>
            <h6 className={'fw_16 fw_600 mb_18 text-color'}>
              Filter
            </h6>
            <div className={'d-flex flex-column checkbox-list mb_48'}>
              <div className="form-check custom-checkbox">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="custom-products-filter"
                  checked={isCustomProductsSelected}
                  onChange={handleCustomProductsChange}
                />
                <label className="form-check-label" htmlFor="custom-products-filter">
                  Custom Products
                </label>
              </div>
            </div>
          </div>

          {loading ? (
            <div className="text-center py-4">
              <p>Loading filters...</p>
            </div>
          ) : error ? (
            <div className="text-center py-4">
              <p className="text-danger">{error}</p>
            </div>
          ) : attributes.length === 0 ? (
            <div className="text-center py-4">
              <p>No filters available.</p>
            </div>
          ) : (
            attributes.map((attribute, index) => (
              <div key={attribute.id || attribute._id || index}>
                <h6 className={'fw_16 fw_600 mb_18 text-color'}>
                  {attribute.name || attribute.attributeName || 'Filter'}
                </h6>

                <div className={'d-flex flex-column checkbox-list mb_48'}>
                  {attribute.values && attribute.values.length > 0 ? (
                    attribute.values.map((value, valueIndex) => {
                      const checkboxId = `${attribute.name}-${value.id || valueIndex}`;
                      return (
                        <div key={value.id || value._id || valueIndex} className="form-check custom-checkbox">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            value={value.id || value._id}
                            id={checkboxId}
                            checked={isChecked(attribute.name, value.id || value._id)}
                            onChange={() =>
                              handleCheckboxChange(
                                attribute.name,
                                value.id || value._id,
                                value.name || value.valueName
                              )
                            }
                          />
                          <label className="form-check-label" htmlFor={checkboxId}>
                            {value.name || value.valueName || 'Option'}
                          </label>
                        </div>
                      );
                    })
                  ) : (
                    <p className="text-muted">No options available</p>
                  )}
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </>
  );
};

export default Sidebar;*/












import React, { useEffect, useState, useRef } from "react";
import FilterIcon from "../../assets/svg/filter.svg";
import { getAttributes } from "../../Services/AttributeService";
const Sidebar = ({ onFilterChange }) => {
  const [attributes, setAttributes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedFilters, setSelectedFilters] = useState({});
  const [isCustomProductsSelected, setIsCustomProductsSelected] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const sidebarRef = useRef(null);
  /* ================= WINDOW RESIZE ================= */
  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  /* ================= FETCH FILTERS ================= */
  useEffect(() => {
    const ac = new AbortController();
    (async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await getAttributes({ attributeIds: [1, 2, 4] });
        setAttributes(response.data || []);
      } catch (err) {
        if (err.name !== "AbortError") setError(err.message || "Failed to load filters");
      } finally {
        setLoading(false);
      }
    })();
    return () => ac.abort();
  }, []);
  /* ================= OUTSIDE CLICK ================= */
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (e.target.closest(".navbar-toggler")) return;
      if (sidebarRef.current && !sidebarRef.current.contains(e.target) && windowWidth < 1024) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [windowWidth]);
  /* ================= HANDLERS ================= */
  const handleCheckboxChange = (attributeName, valueId, valueName) => {
    setSelectedFilters((prev) => {
      const attributeFilters = prev[attributeName] || [];
      const isSelected = attributeFilters.some((item) => item.id === valueId);
      const updatedFilters = {
        ...prev,
        [attributeName]: isSelected
          ? attributeFilters.filter((item) => item.id !== valueId)
          : [...attributeFilters, { id: valueId, name: valueName }],
      };
      if (Object.keys(updatedFilters).some((key) => key !== "isCustomProduct" && updatedFilters[key].length > 0)) {
        setIsCustomProductsSelected(false);
        updatedFilters.isCustomProduct = [];
      }
      onFilterChange?.(updatedFilters);
      return updatedFilters;
    });
    if (windowWidth < 1024) setIsOpen(false);
  };
  const handleCustomProductsChange = () => {
    const newValue = !isCustomProductsSelected;
    setIsCustomProductsSelected(newValue);
    if (newValue) setSelectedFilters({});
    onFilterChange?.({ isCustomProduct: newValue ? [true] : [] });
    if (windowWidth < 1024) setIsOpen(false);
  };
  const isChecked = (attributeName, valueId) => selectedFilters[attributeName]?.some((item) => item.id === valueId);
  /* ================= JSX ================= */
  return (
    <div className="sidebar navbar-expand-xl" ref={sidebarRef}>
      {/* Toggle Button: Only for mobile/tablet */}
      {windowWidth < 1024 && (
        <button
          className="navbar-toggler button btn-solid"
          type="button"
          aria-expanded={isOpen}
          onClick={(e) => { e.stopPropagation(); setIsOpen((p) => !p); }}
        >
          Sort
          <img className="img-fluid ms-2" src={FilterIcon} alt="" />
        </button>
      )}
      {/* Sidebar Content */}
      <div className={`sidebar-content collapse navbar-collapse ${windowWidth >= 1024 || isOpen ? "show" : ""}`}>
        {/* Custom Products */}
        <div>
          <h6 className="fw_16 fw_600 mb_18 text-color">Filter</h6>
          <div className="d-flex flex-column checkbox-list mb_48">
            <div className="form-check custom-checkbox">
              <input
                className="form-check-input"
                type="checkbox"
                id="custom-products-filter"
                checked={isCustomProductsSelected}
                onChange={handleCustomProductsChange}
              />
              <label className="form-check-label" htmlFor="custom-products-filter">
                Custom Products
              </label>
            </div>
          </div>
        </div>
        {/* Filters */}
        {loading && <div className="text-center py-4"><p>Loading filters...</p></div>}
        {error && <div className="text-center py-4"><button style={{ backgroundColor: "#A37C4D", color: "#fff", border: "none", padding: "10px 22px", borderRadius: "6px", fontSize: "14px", cursor: "default" }}>{error}</button></div>}
        {attributes.length === 0 && !loading && !error && <div className="text-center py-4"><p>No filters available.</p></div>}
        {attributes.map((attr, index) => (
          <div key={attr.id || attr._id || index}>
            <h6 className="fw_16 fw_600 mb_18 text-color">{attr.name || attr.attributeName || "Filter"}</h6>
            <div className="d-flex flex-column checkbox-list mb_48">
              {attr.values?.length > 0 ? (
                attr.values.map((v, idx) => (
                  <div key={v.id || v._id || idx} className="form-check custom-checkbox">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id={`${attr.name}-${v.id || idx}`}
                      checked={isChecked(attr.name, v.id || v._id)}
                      onChange={() => handleCheckboxChange(attr.name, v.id || v._id, v.name || v.valueName)}
                    />
                    <label className="form-check-label" htmlFor={`${attr.name}-${v.id || idx}`}>
                      {v.name || v.valueName || "Option"}
                    </label>
                  </div>
                ))
              ) : (
                <p className="text-muted">No options available</p>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
export default Sidebar;